import {
	Box,
	Divider,
	Button,
	styled,
	ButtonProps,
	useTheme,
	useMediaQuery,
	DialogContentText,
	DialogActions,
	DialogTitle,
	DialogContent,
	Dialog, Slide, IconButton
} from '@mui/material';
// import {stateToHTML} from 'draft-js-export-html';
// import {convertFromRaw} from 'draft-js';
// import DOMPurify from 'dompurify';
// import ReactHtmlParser from 'react-html-parser';
import bg from './assets/images/bg-blue.webp';
import title from './assets/images/title.webp';
import option1 from './assets/images/option1.webp';
import option2 from './assets/images/option2.webp';
import gifts from './assets/images/gifts.webp';
import {useTranslation} from 'react-i18next';
import React, {forwardRef, useState, ReactElement, Ref} from 'react';
import {ICompetition} from '../../ICompetitions';
import {TransitionProps} from '@mui/material/transitions';
import CloseIcon from '@icons/CloseIcon';

import {Link} from 'react-router-dom';

type IProps = {
	competition: ICompetition,
	referrer: string,
	referral: string | undefined
}
const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: ReactElement<any, any>;
	},
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props}/>;
});
const ColorButton = styled(Button)<ButtonProps>(({theme}) => ({
	color: theme.palette.getContrastText('rgb(232 190 115)'),
	backgroundColor: 'rgb(232 190 115)',
	'&:hover': {
		backgroundColor: 'rgb(232 190 115)'
	}
}));
export default function ImamrezaCompetition(props: IProps) {
	const {competition, referrer, referral} = props;
	const {t} = useTranslation();
	const [open, setOpen] = useState(false);
	const theme = useTheme();
	const [initialData, setInitialData] = useState('');
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	
	// const getHTMLData = (value: any) => {
	// 	setInitialData(stateToHTML(convertFromRaw(JSON.parse(value))));
	// };
	// useEffect(() => {
	// 	getHTMLData(competition.description);
	// }, []);
	const handleClickOpen = () => {
		setOpen(true);
	};
	
	const handleClose = () => {
		setOpen(false);
	};
	
	// function createMarkup(html: any) {
	// 	return {
	// 		__html: DOMPurify.sanitize(html)
	// 	};
	// }
	
	return (
		<>
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				scroll={'paper'}
				TransitionComponent={Transition}
				keepMounted={true}
				aria-labelledby="responsive-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="responsive-dialog-title">
					{t('competitions.conditions')}
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500]
					}}
				>
					<CloseIcon/>
				</IconButton>
				<DialogContent dividers={true}>
					{/*<DialogContentText dangerouslySetInnerHTML={createMarkup(initialData)}>*/}
					<DialogContentText dangerouslySetInnerHTML={{__html: competition.description as string}}>
						{/*{*/}
						{/*	ReactHtmlParser(initialData)*/}
						{/*}*/}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						{t('competitions.understood')}
					</Button>
				</DialogActions>
			</Dialog>
			<Box className="flex flex-col w-full h-[calc(100vh-55px)] overflow-hidden justify-center align-middle"
			     sx={{
				     backgroundImage: `url(${bg})`,
				     backgroundRepeat: 'no-repeat',
				     backgroundSize: 'cover'
			     }}
			>
				<div className="flex flex-col mx-8 h-full content-around justify-around items-center">
					<div className="flex flex-row w-4/6 justify-center mt-20">
						<img src={title} alt="title"/>
					</div>
					<div className="flex flex-row w-full justify-around">
						<Link to={`/questions/${competition.id}/new`} state={{referrer: referrer, referral: referral}}
						      className="w-[48%] scaleAnimate">
							<img src={option1} alt="start"/>
						</Link>
						<Link to={`/questions/${competition.id}/continue`} state={{referrer: referrer, referral: referral}}
						      className="w-[48%]">
							<img src={option2} alt="continue"/>
						</Link>
					</div>
					<div>
						<ColorButton variant="contained" className="rounded-3xl" onClick={handleClickOpen}>
							{t('competitions.more_info')}
						</ColorButton>
					</div>
					<Divider className="h-20"/>
					<div className="">
						<img src={gifts} alt="gifts"/>
					</div>
				</div>
			</Box>
		</>
	);
}
